export class UserError extends Error {
  constructor(...args) {
    super(...args)

    Error.captureStackTrace(this, UserError)
  }
}
